import * as React from 'react';
import { parseQueryParams, removeQueryParams, stringifyQuery } from '@/utils/queryParams';
import { useHistory, useLocation } from 'react-router-dom';
import { openForgotPasswordModal } from '@/redux/modules/modal';
import { useDispatch } from 'react-redux';

const ForgotPasswordAction = () => {
    const location = useLocation();
    const { push } = useHistory();
    const queryParams: any = React.useMemo(() => parseQueryParams(location.search), [location.search]);
    const dispatch = useDispatch();

    React.useEffect(() => {
        if (queryParams.action === 'forgot') {
            const query = removeQueryParams(queryParams, ['action']);
            const stringified = stringifyQuery(query);
            const newLocation = location.pathname + stringified ? '?' + stringified : '';
            dispatch(openForgotPasswordModal());
            push(newLocation);
        }
    }, [dispatch, location, queryParams, push]);

    return null;
};

export default ForgotPasswordAction;
